import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import ViewStoryArrowComponent from "components/ViewStoryArrowComponent";
import { keyboardEventPassthroughHandler } from "utils/keyboardEventPassthroughHandler";
import styles from "./ViewStoryButtonStyles.css";

export default function ViewStoryButton(props) {
  return (
    <div
      aria-label="View Story"
      className={classnames(styles.root, {
        svgContent: props.customIcon,
      })}
      onClick={() => props.onClick()}
      onKeyUp={keyboardEventPassthroughHandler(props.onClick)}
      role="button"
      tabIndex={0}
    >
      {props.text && props.text.length > 0 && (
        <span className="story-action">{props.text}</span>
      )}
      <ViewStoryArrowComponent customIcon={props.customIcon} scaling={false} />
    </div>
  );
}

ViewStoryButton.propTypes = {
  customIcon: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};
